import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const PromotionPreview = () => {
  const [code, setCode] = useState('');
  const [applied, setApplied] = useState(false);
  return <details className="sr-promo" data-testid="signup-review-promo-section">
    <summary data-testid="signup-review-promo-toggle">Have a promotion code?</summary>
    <div>
      <Input aria-label="Promotion code preview" value={code} maxLength={80} onChange={event => { setCode(event.target.value); setApplied(false); }} className="sr-input" data-testid="signup-review-promo-input" />
      <Button type="button" className="sr-secondary" disabled={!code.trim()} onClick={() => setApplied(true)} data-testid="signup-review-promo-apply">Apply</Button>
    </div>
    {applied && <p className="sr-mock-note" role="status" data-testid="signup-review-promo-notice">MOCKED preview — no promotion code was applied.</p>}
  </details>;
};